import { DependentProfileVersionDto } from '../dtos'
import { PersonalInfo } from '../../PersonalInfo'
import { observable, makeObservable } from 'mobx'

import { Model } from 'infra/model'
import { Id } from 'types/definitions'
import { DateZero, maybeParseDate } from 'utils/date-util'
import { timestampToISO } from 'utils/grpc-util'

export class DependentProfileVersion extends Model<
  DependentProfileVersionDto,
  DependentProfileVersion
> {
  @observable
  id = Id.none

  @observable
  version = 0

  @observable
  workspaceId = ''

  @observable
  ownerUserId = ''

  @observable
  personalInfo?: PersonalInfo

  @observable
  relationship?: string

  @observable
  createTime = DateZero()

  @observable
  updateTime = DateZero()

  static get none() {
    return lazyNone()
  }

  constructor() {
    super()
    makeObservable(this)
  }

  parse(
    attrs: Partial<DependentProfileVersionDto>,
  ): Partial<DependentProfileVersion> {
    return {
      id: attrs.id,
      version: attrs.version,
      workspaceId: attrs.workspaceId,
      ownerUserId: attrs.ownerUserId,
      personalInfo: attrs.personalInfo
        ? new PersonalInfo().set(attrs.personalInfo, { parse: true })
        : attrs.personalInfo,
      relationship: attrs.relationship,
      createTime: maybeParseDate(timestampToISO(attrs.createTime)),
      updateTime: maybeParseDate(timestampToISO(attrs.createTime)),
    }
  }
}
function lazyNone() {
  throw new Error('Function not implemented.')
}
